import React from 'react';
import { Form } from 'react-bootstrap';
import { RRule } from 'rrule';

const WeekdaysSelector = ({ selectedWeekdays, setSelectedWeekdays }) => {
  console.log('WeekdaysSelector rendered with selectedWeekdays:', selectedWeekdays);
  const handleWeekdayChange = (day) => (e) => {
    const checked = e.target.checked;
    let newSelected = checked
      ? [...selectedWeekdays, day]
      : selectedWeekdays.filter((d) => d !== day);
    newSelected.sort((a, b) => {
      const order = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
      return order.indexOf(a) - order.indexOf(b);
    });
    setSelectedWeekdays(newSelected);
  };

  return (
    <Form.Group className="mb-3 w-100">
      <div className="d-flex flex-row mb-2 w-100 justify-content-between">
        <Form.Label className="fw-bold text-white mb-2"></Form.Label>
        <div className="d-flex flex-row">
          {['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'].map((day) => {
            const isChecked = selectedWeekdays.includes(day);
            return (
              <Form.Check
                key={day}
                type="checkbox"
                id={`weekday-${day}`}
                label={day}
                className="text-white me-3"
                checked={isChecked}
                onChange={handleWeekdayChange(day)}
              />
            );
          })}
        </div>
      </div>
    </Form.Group>
  );
};

export default WeekdaysSelector;
